<template>
    <div v-if="userData.role != 'CS'">
      <b-overlay
      :show="loading"
      rounded="lg"
    > 
      <b-row>

        <b-col
          cols="12"
          md="3"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
        <v-select
                v-model="year"
                label="title"
                :clearable="false"
                :options="yearOptions"
                />
                <!-- <flat-pickr
          v-model="year"
          class="form-control mb-1 mr-1"
          :config="{ mode: 'range',dateFormat: 'Y-m'}"
        /> -->
      </b-col>
        <b-col
          cols="12"
          md="9"
        >
          <div class="d-flex align-items-center justify-content-end">
  
          
            <b-button
              variant="primary"
              class="mb-1"
              @click="exportToExcel()"
            >
              <span class="text-nowrap">Export</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <b-table
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        :items="items"
        :fields="fields"
        responsive
        striped
        class="mb-0"
       
      >
        <template #cell(center)="data">
          <b-badge variant="primary" class="d-block">
           {{data.item.center}} 
          </b-badge>
        </template>
       
        <template #cell(01)="data">{{ data.item['01'] }}</template>
        <template #cell(02)="data">{{ data.item['02'] }}</template>
        <template #cell(03)="data">{{ data.item['03'] }}</template>
        <template #cell(04)="data">{{ data.item['04'] }}</template>
        <template #cell(05)="data">{{ data.item['05'] }}</template>
        <template #cell(06)="data">{{ data.item['06'] }}</template>
        <template #cell(07)="data">{{ data.item['07'] }}</template>
        <template #cell(08)="data">{{ data.item['08'] }}</template>
        <template #cell(09)="data">{{ data.item['09'] }}</template>
        <template #cell(10)="data">{{ data.item['10'] }}</template>
        <template #cell(11)="data">{{ data.item['11'] }}</template>
        <template #cell(12)="data">{{ data.item['12'] }}</template>


      </b-table>
      </b-overlay>
    </div>
  </template>
  
  <script>
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  
  import vSelect from 'vue-select'
  import Ripple from 'vue-ripple-directive'
  import flatPickr from 'vue-flatpickr-component'
  import moment from 'moment'
  // import VueNumberFormat from '@igortrindade/vue-number-format'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import {
    BTable, BAvatar, BOverlay,BCardBody, BBadge,  BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
  export default {
    components: {
      moment,BOverlay,
      flatPickr,
      BTable,
      // VueNumberFormat,
      ToastificationContent,
      BModal, VBModal,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroupPrepend,
      BButton,
      BPagination,
      BCardCode,
      BTable,
      BButton,
      BFormGroup,
      BAvatar,
      BCardBody,
      BBadge,
      vSelect,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        loading:false,
        format_option : {
          prefix: '',
          suffix: '',
          decimal: '.',
          thousand: ',',
          precision: 2,
          acceptNegative: true,
          isInteger: false
        },
        iframe_src : '//rb.cloudedu.pro/invoice.php',
        rangeDate: null,
        userData:JSON.parse(localStorage.getItem('userData')),
        searchString: null,
        type:'all',
        test_string : null,
        headerTitle: ['Center','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
        headerVal: ['center','01','02','03','04','05','06','07','08','09','10','11','12'],
        genderOptions: [
          { label: 'Male', value: 'M' },
          { label: 'Female', value: 'F' },
        ],
        planOptions: [
          { label: 'Basic', value: 'basic' },
          { label: 'Company', value: 'company' },
          { label: 'Enterprise', value: 'enterprise' },
          { label: 'Team', value: 'team' },
        ],
        typeOptions: [
          { label: 'All', value: 'all' },
          { label: 'Membership', value: 'MEMBERSHIP' },
          { label: 'Product', value: 'PRODUCT' },
          { label: 'Package', value: 'PACKAGE' },
          { label: 'Rental', value: 'RENTAL' }
        ],
        statusOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Disabled', value: 'disabled' },
        ],
        centerOptions: [],
        yearOptions:[],
        isAddNewMemberSidebarActive: false,
        searchString: null,
        perPage: 10,
        startRow: 1,
        year: moment().format("YYYY"),
        endRow: 10,
        totalAmount: 0,
        pageOptions: [10, 15, 20],
        totalRows: 1,
        centerOptions: [],
        currentPage: 1,
        fields: [   { key: 'center', label: 'Center',sortable:true ,stickyColumn: true, isRowHeader: true,variant: 'primary'},
                    
                    { key: '01', label: 'Jan',sortable:true },
                    { key: '02', label: 'Feb',sortable:true },
                    { key: '03', label: 'Mar',sortable:true },
                    { key: '04', label: 'Apr',sortable:true },
                    { key: '05', label: 'May',sortable:true },
                    { key: '06', label: 'Jun',sortable:true },
                    { key: '07', label: 'Jul',sortable:true },
                    { key: '08', label: 'Aug',sortable:true },
                    { key: '09', label: 'Sep',sortable:true }, 
                    { key: '10', label: 'Oct',sortable:true }, 
                    { key: '11', label: 'Nov',sortable:true }, 
                    { key: '12', label: 'Dec',sortable:true },
                    
                ],
        /* eslint-disable global-require */
        items: [],
        /* eslint-disable global-require */
        status: [{
          1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
        },
        {
          1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
        }],
        selectMode: 'single',
        selected: [],
      }
    },
    watch: {
      type: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      year : {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      currentPage: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      searchString: {
        handler(newValue, oldValue) {
          // console.log("search")
          this.searchString = newValue.toUpperCase()
          this.handleSearch()
        },
      },
      perPage: {
        handler(newValue, oldValue) {
          if (newValue < 9) {
            this.perPage = 10
          }
          // console.log("search")
          this.handleSearch()
        },
      },
    },
    created() {
      this.calculatePastYears()
      this.get_data()
      this.get_center_data()
    },
    methods: {
      calculatePastYears() {
        const startYear = 2023;
        const currentYear = new Date().getFullYear();
        for (let i = startYear; i <= currentYear; i++) {
          this.yearOptions.push(i);
        }
      },
      exportToExcel() {
        console.log(this.items)
        console.log(this.headerTitle)
        import('@/@core/Export2Excel').then(excel => {
          const list = this.items
          const data = this.formatJson(this.headerVal, list)
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: 'Sales_monthly',
            autoWidth: true,
            bookType: 'xlsx'
          })
          //this.clearFields()
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v =>
          filterVal.map(j => {
            // Add col name which needs to be translated
            // if (j === 'timestamp') {
            //   return parseTime(v[j])
            // } else {
            //   return v[j]
            // }
  
            return v[j]
          })
        )
      },
      get_data(searchString = null) {
        this.loading = true
        this.$http.get(process.env.VUE_APP_API_BASE+`/report/sales-monthly/?year=`+this.year)
          .then(res => {
            this.items = res.data
            this.totalRows = this.items.length
            this.totalAmount = 0
              console.log( res.data )
              this.items.forEach((item, i) => {
                if (item.status == 'ACTIVE') {
                  this.totalAmount += parseInt(item.amount)
                }
              });
              this.loading = false
          })
      },
      get_center_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
          .then(res => {
            this.centerOptions = res.data.centers
          })
      },
      handleChangePage() {
  
      //  this.get_data()
      },
      onRowSelected(items) {
        this.selected = items[0]
        this.iframe_src = '//rb.cloudedu.pro/pdf/INVOICE_'+items[0].code+'.pdf'
        this.transaction_id = items[0].transaction_id
        this.$refs['my-modal'].show()
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      selectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.selectRow(2)
      },
      unselectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.unselectRow(2)
      },
  
      handleSearch() {
        // let _print = `The user searched for: ${searching}\n`
        // this.$refs.pre.appendChild(document.createTextNode(_print))
      // this.searchString = searching
      // this.currentx = 1
      // this.get_data()
        this.searchTimeOut()
      },
      searchTimeOut() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          // your code
          this.currentPage = 1
          this.get_data(this.searchString)
        }, 500)
      },
    },
  }
  </script>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  </style>
  <style lang="scss">
  .b-table-selectable{
    .feather{
      font-size: 1.3rem;
    }
  }
  
  </style>
  